/* eslint-disable camelcase */

import { computed, makeObservable, observable, toJS } from 'mobx'
import Model from './Model'

class Address extends Model {
  @observable city = ''
  @observable country = ''
  @observable id
  @observable created = ''
  @observable modified = ''
  @observable postal_code = ''
  @observable province = ''
  @observable room = ''
  @observable route = ''

  _isDirty = false
  _fieldToSave = [
    'city',
    'country',
    'id',
    'postal_code',
    'province',
    'room',
    'route'
  ]

  @computed
  get fullAddress () {
    let result = ''
    if (this.room) {
      result += `#${this.room} `
    }
    if (this.route) {
      result += this.route
    }
    if (this.city) {
      result += `, ${this.city}`
    }
    if (this.province) {
      result += `, ${this.province}`
    }
    if (this.country) {
      result += `, ${this.country}`
    }
    if (this.postal_code) {
      result += `, ${this.postal_code}`
    }

    return result.trim()
  }

  constructor () {
    super()
    makeObservable(this)
  }

  toJson () {
    const address = {}
    for (const props of this._fieldToSave) {
      address[props] = toJS(this[props])
    }
    return address
  }
}

export default Address
